import dynamic from "next/dynamic";

// Dynamically import only what you need
export const MotionDiv = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.div),
  { ssr: false }
);
export const MotionSection = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.section),
  { ssr: false }
);
export const MotionSpan = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.span),
  { ssr: false }
);
export const MotionButton = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.button),
  { ssr: false }
);
export const MotionH1 = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.h1),
  { ssr: false }
);
export const MotionH2 = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.h2),
  { ssr: false }
);
export const MotionP = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.p),
  { ssr: false }
);
export const MotionUl = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.ul),
  { ssr: false }
);
export const MotionLi = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.li),
  { ssr: false }
);
export const MotionPath = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.path),
  { ssr: false }
);
export const MotionSvg = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.svg),
  { ssr: false }
);
export const MotionA = dynamic(() =>
  import("framer-motion").then(mod => mod.motion.a),
  { ssr: false }
);

export const AnimatePresence = dynamic(() =>
  import("framer-motion").then(mod => mod.AnimatePresence),
  { ssr: false }
);
